<template>
  <!--	노션 링크 : https://www.notion.so/ReservInfoPage-0cd7c8d24f8347569f8c57ffffdbae15 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="premiumbenefits_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">PREMIUM BENEFITS</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('benefit_title') }}</strong>
        </h2>
      </div>
    </div>
    <div class="rowSpace"></div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->

        <GallerySlideCarousels :slides="premium_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('benefit_subtitle') }}</div>
          <div class="web">
            <div v-for="(item, index) in premium_items" :key="index">
              <div v-if="index % 2 === 0" class="d-flex">
                <div class="w-50"><img :src="item.image" /></div>
                <div class="w-50 align-self-center pl-5">
                  <div class="tHeader text-left">
                    {{ $t(item.title) }}
                  </div>

                  <div class="tBody text-left" v-html="$t(item.desc)"></div>
                </div>
              </div>
              <div v-else class="d-flex">
                <div class="w-50 align-self-center pr-5">
                  <div class="tHeader text-right">
                    {{ $t(item.title) }}
                  </div>
                  <div class="tBody text-right" v-html="$t(item.desc)"></div>
                </div>
                <div class="w-50"><img :src="item.image" /></div>
              </div>
            </div>
          </div>
          <div class="mobile">
            <div v-for="(item, index) in premium_items" :key="index" class="mb-4 border">
              <div class="w-100"><img :src="item.image" /></div>
              <div class="w-100 align-self-center p-3">
                <div class="tHeader text-left">
                  {{ $t(item.title) }}
                </div>
                <div class="tBody text-left" v-html="$t(item.desc)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Premiumbenefits',
  data() {
    return {
      isLang: 0,
      premiumbenefits_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      premium_slides: [
        // {image: require('@/assets/images/pleisure/premium/premium_slideimage06.jpg')},
        {image: require('@/assets/images/pleisure/premium/premium_slideimage01.jpg')},
        {image: require('@/assets/images/pleisure/premium/premium_slideimage02.jpg')},
        {image: require('@/assets/images/pleisure/premium/premium_slideimage03.jpg')},
        {image: require('@/assets/images/pleisure/premium/premium_slideimage04.jpg')},
        {image: require('@/assets/images/pleisure/premium/premium_slideimage05.jpg')},
      ],
      premium_items: [
        {
          title: 'benefit_service_title1',
          desc: 'benefit_service_desc1',
          image: require('@/assets/images/pleisure/premium/premium_bodyimage01.jpg'),
        },
        {
          title: 'benefit_service_title2',
          desc: 'benefit_service_desc2',
          image: require('@/assets/images/pleisure/premium/premium_bodyimage02.jpg'),
        },
        {
          title: 'benefit_service_title4',
          desc: 'benefit_service_desc4',
          image: require('@/assets/images/pleisure/premium/premium_bodyimage04.jpg'),
        },
        // {
        //   title: 'benefit_service_title3',
        //   desc: 'benefit_service_desc3',
        //   image: require('@/assets/images/pleisure/premium/premium_bodyimage03.jpg'),
        // },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
p,
h1,
h2,
h3,
h4,
h5 {
  word-break: keep-all;
}
li {
  list-style: none;
}
li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}
.card-img-top {
  object-fit: cover;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}

.subTitle {
  text-align: center;
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.tBody {
  word-break: keep-all;
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/premium_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .web {
    display: none;
  }
  .mobile {
    display: block;
  }
  .tHeader {
    font-size: 1rem;
  }
  .tBody {
    font-size: 0.9rem;
  }

  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
}
img {
  width: 100%;
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프리미엄 혜택",
    "benefit_title": "프리미엄 혜택",
    "benefit_subtitle": "프리미엄 레저 서비스",
    "benefit_service_title1": "단 한 팀만을 위한 스케줄링 서비스",
    "benefit_service_desc1": "핀크스 레저의 모든 일정은 ʻ프라이빗 투어’로<br/>럭셔리 풀 패키지 여행을 위한<br/>인원, 연령, 시간, 성향에 따른 구성을 통해<br/>고객 맞춤형 Bespoke 스케줄 서비스를 제공합니다.",
    "benefit_service_title2": "격조높은 차량 의전 서비스",
    "benefit_service_desc2": "High-end 고객을 위하여 의전 서비스 전문가가 운행하는<br/>레저-숙소 간 이동 서비스를 제공합니다.<br/>단독 차량 의전과 차량 내에서 제공되는 미니바와 함께<br/>프라이빗하고 편안한 레저를 경험하세요.<br/>(카니발 하이리무진 / 벤츠 스프린터)",
    "benefit_service_title3": "레저 특화 어메니티/F&B 서비스",
    "benefit_service_desc3": "고객님의 한 층 더 편안한 레저를 위하여<br/>각 프로그램 마다 특화된 어메니티와<br/>레저 전/후에 이용하실 수 있는 프로그램별<br/>맞춤 F&B 서비스가 준비되어 있습니다.",
    "benefit_service_title4": "단체 행사 프리미엄 레저 연계",
    "benefit_service_desc4": "MICE 행사 성격에 부합하는 요트, 승마, 골프레슨 등의<br/>럭셔리 레저와 제주 특색을 경험할 수 있는<br/>곶자왈 큐레이팅, 오름 트래킹 등의 Local 레저를<br/>참석자의 Needs에 맞추어 제안합니다."
  },

  "en": {
    "breadcrumb": "Premium Benefit",
    "benefit_title": "Premium Benefit",
    "benefit_subtitle": "Premium Leisure Service",
    "benefit_service_title1": "Scheduling service for only one team.",
    "benefit_service_desc1": "PINX Leisure operates all tours in private, providing bespoke scheduling service by organizing the full package tour based on number of people, age, time and preference.",
    "benefit_service_title2": "Classy vehicle escort service",
    "benefit_service_desc2": "For high-end customers, we provide the escort service between leisure and accommodation operated by the escort service specialist. Experience private and comfortable leisure with a vehicle escort service and free minibar provided in the car.<br/>(The Kia EV9 / Carnival High Limousine / Benz Sprinter)",
    "benefit_service_title3": "Leisure specialized amenities / F&B service",
    "benefit_service_desc3": "For more comfortable leisure, we provide specialized amenities for each program and customized F&B services before and after each leisure program.",
    "benefit_service_title4": "Premium leisure for group event",
    "benefit_service_desc4": "We offer a special program for the MICE group, tailored to the participants' needs for the luxury leisure such as yacht, horseback riding, and golf lesson, and local leisure such as Gotjawal curating and Oreum trekking to experience local Jeju."
  },
  "ja": {
    "breadcrumb": "프리미엄 혜택",
    "benefit_title": "프리미엄 혜택",
    "benefit_subtitle": "프리미엄 레저 서비스",
    "benefit_service_title1": "단 한 팀만을 위한 스케줄링 서비스",
    "benefit_service_desc1": "핀크스 레저의 모든 일정은 ʻ프라이빗 투어’로<br/>럭셔리 풀 패키지 여행을 위한<br/>인원, 연령, 시간, 성향에 따른 구성을 통해<br/>고객 맞춤형 Bespoke 스케줄 서비스를 제공합니다.",
    "benefit_service_title2": "격조높은 차량 의전 서비스",
    "benefit_service_desc2": "High-end 고객을 위하여 의전 서비스 전문가가 운행하는<br/>레저-숙소 간 이동 서비스를 제공합니다.<br/>단독 차량 의전과 차량 내에서 제공되는 미니바와 함께<br/>프라이빗하고 편안한 레저를 경험하세요.<br/>(카니발 하이리무진 / 벤츠 스프린터)",
    "benefit_service_title3": "레저 특화 어메니티/F&B 서비스",
    "benefit_service_desc3": "고객님의 한 층 더 편안한 레저를 위하여<br/>각 프로그램 마다 특화된 어메니티와<br/>레저 전/후에 이용하실 수 있는 프로그램별<br/>맞춤 F&B 서비스가 준비되어 있습니다.",
    "benefit_service_title4": "단체 행사 프리미엄 레저 연계",
    "benefit_service_desc4": "MICE 행사 성격에 부합하는 요트, 승마, 골프레슨 등의<br/>럭셔리 레저와 제주 특색을 경험할 수 있는<br/>곶자왈 큐레이팅, 오름 트래킹 등의 Local 레저를<br/>참석자의 Needs에 맞춘 커스텀 프로그램을 제안합니다."
  }
}
</i18n>
